import { render, staticRenderFns } from "./alt-collapse.vue?vue&type=template&id=7f252cd0&"
import script from "./alt-collapse.vue?vue&type=script&lang=ts&"
export * from "./alt-collapse.vue?vue&type=script&lang=ts&"
import style0 from "./alt-collapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports